import { render, staticRenderFns } from "./LogoWithTextIcon.vue?vue&type=template&id=92d8832c&scoped=true&"
import script from "./LogoWithTextIcon.vue?vue&type=script&lang=js&"
export * from "./LogoWithTextIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d8832c",
  null
  
)

export default component.exports